module.exports = __webpack_public_path__ + "img/banner-3-1.37302c8a.png";